module.exports = function getrandmax() {
  //  discuss at: https://locutus.io/php/getrandmax/
  // original by: Onno Marsman (https://twitter.com/onnomarsman)
  //   example 1: getrandmax()
  //   returns 1: 2147483647

  return 2147483647
}
